import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppAuthServiceService } from '@core';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate, CanLoad {
  constructor(private appAuthService: AppAuthServiceService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const promise = new Promise<boolean>((resolve) => {
      this.appAuthService.isReady.subscribe(() => {
        if (this.appAuthService.isAdmin.getValue()) {
          resolve(true);
        } else {
          this.router.navigate(['/home']);
          resolve(false);
        }
      });
    });

    if (this.appAuthService.isLoggedIn.getValue() && this.appAuthService.isAdmin.getValue()) {
      return true;
    } else {
      return promise;
    }
  }
  canLoad(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const promise = new Promise<boolean>((resolve) => {
      this.appAuthService.isReady.subscribe(() => {
        if (this.appAuthService.isAdmin.getValue()) {
          resolve(true);
        } else {
          this.router.navigate(['/home']);
          resolve(false);
        }
      });
    });

    return this.appAuthService.isLoggedIn.getValue() && this.appAuthService.isAdmin.getValue() ? true : promise;
  }
}
